import { render } from "./PreviewUnit.vue?vue&type=template&id=4545a973&scoped=true"
import script from "./PreviewUnit.vue?vue&type=script&lang=js"
export * from "./PreviewUnit.vue?vue&type=script&lang=js"

import "./PreviewUnit.vue?vue&type=style&index=0&id=4545a973&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4545a973"]])

export default __exports__